export const planesElements = {
    ESTANDAR: 1,
    PRO: 2,
    PREMIUM: 3
}